<template>
  <div
    class="radio-button-text-group-container"
    :style="`width: ${full_width ? '100%' : ''};`"
    @mouseover="is_hovered=true"
    @mouseleave="is_hovered=false"
  >
    <div
      :id="id"
      class="radio-button-text-group-button-container"
      :style="`
        min-height:${min_height || 34}px;
        max-height:${max_height || 34}px;`"
    >
      <button
        :style="`
          padding: ${padding_vertical}px ${padding_horizontal}px;
          flex: ${full_width ? '1 1 0px' : ''};
        `"
        v-for="(element, index) in elements"
        :key="`${id}${index}`"
        v-ripple
        :disabled="element.disabled"
        @click="handleClick(element, index)"
      >
        <TText :value="element.text" :color="color" :font_weight="font_weight || 500" />
      </button>
    </div>
    <div
      class="radio-button-text-group-underlined"
      :style="`
        border-color: ${is_hovered
          ? getColor(color)
          : getTranspHexColor(getColor(color), .7)};
        width: ${underline_width}px;
        margin-left: ${underline_margin}px;
      `"
    />
  </div>
</template>

<script>
import { TColor } from '@/mixins/TColor.mixin.js';
import TText from '@/components/Taktify/TText.component.vue'

  export default {
    components: {
      TText,
    },

    mixins: [
      TColor,
    ],

    props: [
      'id',
      'elements',
      'selected',
      'color',
      'font_weight',
      'min_height',
      'max_height',
      // 'full_width', // is boolean, is handled in computed
    ],

    data: () => ({
      padding_horizontal: 12,
      padding_vertical: 4,
      underline_width: 0,
      underline_margin: 0,
      selected_id: -1,
      is_hovered: false,
    }),

    mounted() {
      let index = 0; // 1 because underline is first item
      if(this.selected) {
        for(index = 0; index < this.elements.length; index++) {
          if(this.selected === this.elements[index].value) {
            break;
          }
        }
      }
      this.selected_id = index;
    },

    watch: {
      selected_id: {
        handler(newVal){
          let child = document.getElementById(this.id).children[newVal]; // +1 because underline is first item
          this.underline_width = child.offsetWidth;
          this.underline_margin = child.offsetLeft;
        },
      }
    },

    computed: {
      full_width() {
        let a = this.$attrs;
        if(a.full_width !== undefined) {
          if(a.full_width || a.full_width === '')
            { return true; } }
        return false;
      },
    },

    methods: {
      handleClick(element, index) {
        this.selected_id = index;
        this.$emit('buttonClicked', element.value);
      },
    },
  }
</script>

<style>
  .radio-button-text-group-container {
    display: flex;
    flex-direction: column;
    position: relative;
    margin: 8px;
  }
  .radio-button-text-group-button-container {
    display: flex;
    flex-direction: row;
    height: 100%;
    flex-shrink: 0;
  }
  .radio-button-text-group-underlined {
    position: absolute;
    bottom: 0;
    border-top: 1px solid;
    transition: all .33s ease-in-out;
    display: flex;
    justify-content: center;
  }
</style>
